<template>
    <div class="media">
      <el-drawer
        title="采访记录"
        :visible.sync="media_questions_obj.media_questions_flag"
        @close='closeHandle'
        size='70%'>
            <el-form label-position="right" label-width="200px"  class="questions">
                <div class="userinfo">
                  <img src="../../assets/my/dy.png" alt="" class="type_img" v-if='kol_user.type_name == "抖音"'>
                  <img src="../../assets/my/ks.png" alt="" class="type_img" v-if='kol_user.type_name == "快手"'>
                  {{kol_user.nickname}} 
                </div>
                <el-form-item label="1、粉丝画像："></el-form-item>
                <el-form-item label="年龄">
                {{kol_questions.age}}
                </el-form-item>
                <el-form-item label="男女比例">
                {{kol_questions.gender}}
                </el-form-item>
                <el-form-item label="地域">
                {{kol_questions.province}}
                </el-form-item>
                <el-form-item label="是否有粉丝群">
                <span v-if="kol_questions.is_fandom ==1">是</span>
                <span v-if="kol_questions.is_fandom ==2">否</span>
                </el-form-item>
                <el-form-item label="2、是否开始直播带货">
                <span v-if="kol_questions.is_live ==1">是</span>
                <span v-if="kol_questions.is_live ==2">否</span>
                </el-form-item>
                <el-form-item label="3、带货直播情况下："></el-form-item>
                <el-form-item label="带货直播平均在线人数">
                {{kol_questions.online_num}}
                </el-form-item>
                <el-form-item label="带货直播在线人数峰值">
                {{kol_questions.online_max}}
                </el-form-item>
                <el-form-item label="带货直播时长">
                {{kol_questions.live_time}}小时
                </el-form-item>
                <el-form-item label="带货直播间人均停留时长">
                <span v-if='kol_questions.stay_time==1'>1min</span>
                <span v-if='kol_questions.stay_time==2'>1-2 min</span>
                <span v-if='kol_questions.stay_time==3'>2-3 min</span>
                <span v-if='kol_questions.stay_time==4'>3 min以上</span>
                </el-form-item>
                <el-form-item label="带货直播单粉产值">
                {{kol_questions.one_fan_gmv}}
                </el-form-item>
                <el-form-item label="4、直播带货主要类目">
                <div v-if="kol_questions_live_category !=''">
                    <el-tag class="mr5" :key="index" v-for="(item,index) in kol_questions_live_category">{{item.smzdm_category_1_name}}</el-tag>
                </div>
                </el-form-item>
                <el-form-item label="场均GMV" v-if="kol_questions.avg_gmv">
                  {{kol_questions.avg_gmv}}
                </el-form-item>
                <el-form-item label="GMV说明" v-if="kol_questions.gmv_desc">
                  {{kol_questions.gmv_desc}}
                </el-form-item>
                <el-form-item label="5、是否做过品牌专场">
                <span v-if="kol_questions.is_brand ==1">是</span>
                <span v-if="kol_questions.is_brand ==2">否</span>
                </el-form-item>
                <el-form-item label="整场坑位数量">
                <span v-if='kol_questions.place_num==1'>1~8</span>
                <span v-if='kol_questions.place_num==2'>9~16</span>
                <span v-if='kol_questions.place_num==3'>17~23</span>
                <span v-if='kol_questions.place_num==4'>24~30</span>
                </el-form-item>
                <el-form-item label="6、直播周次">
                <div>{{kol_questions.live_week_num}}</div> 
                </el-form-item>
                <el-form-item label="从收样到上线需几天">
                {{kol_questions.online_days}}
                </el-form-item>
                <el-form-item label="7、品牌方权益保障">
                {{kol_questions.brand_desc}}
                </el-form-item>
                <el-form-item label="8、是否可ROI保量">
                <span v-if="kol_questions.is_roi ==1">是</span>
                <span v-if="kol_questions.is_roi ==2">否</span>
                </el-form-item>
                <el-form-item label="ROI保量值" v-if="kol_questions.roi">
                {{kol_questions.roi}}
                </el-form-item>
                <el-form-item label="9、倾向品牌" >
                <div v-if="kol_questions_brand !=''">
                    <el-tag class="mr5" :key="index" v-for="(item,index) in kol_questions_brand">{{item.cn_title}}</el-tag>
                </div>
                </el-form-item>
                <el-form-item label="倾向类目">
                <div v-if="kol_questions_category !=''">
                    <el-tag class="mr5" :key="index" v-for="(item,index) in kol_questions_category">{{item.smzdm_category_1_name}}</el-tag>
                </div>
                </el-form-item>
            </el-form>
        </el-drawer>
  </div>
</template>
<script>
import apiUrl from "@/config/api.js";
import utils from "@/utils/util.js";

export default {
  name: "media_questions",
  props:{
    media_questions_obj: {
      media_questions_flag: false,
      klurid: ""
    }
      // klurid:'',
  },
  data() {
    return {
      api:{
        getKolQuestions:'home/getKolQuestions',
      },
      kol_questions: {},
      kol_questions_live_category: [],
      kol_questions_category: [],
      kol_questions_brand: [],
      kol_user:'',
    };
  },
  created() {
    console.log(this.media_questions_obj)
    this.getQuestion()
  },
  methods: {
    // 获取达人类目
    getQuestion() {
      let _this = this;
      _this
        .$http({
          method: "GET",
          url: _this.api.getKolQuestions,
          params: {
            klurid: _this.media_questions_obj.klurid
          }
        })
        .then(res => {
          if (res.code == 1) {
            let info = res.data.info;
            for(let key in info){
              _this[key] = info[key]
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    closeHandle(){
        this.$emit('mediaQuestionsColse')
    }
  }
};
</script>
<style scoped>

.questions >>> .el-form-item{
  margin-bottom: 5px;
}
.mr5{
  margin-right: 5px;
}
.userinfo{
  margin-bottom: 10px;
  font-size: 20px;
  padding-left: 30px;
  color: #252328;;
}
.type_img{
  width: 16px;
  height: 16px;
}
.media >>> .el-drawer__body {
    overflow: auto;
    /* overflow-x: auto; */
}

/*2.隐藏滚动条，太丑了*/
.media >>> .el-drawer__container ::-webkit-scrollbar{
    display: none;
}
</style>